import gql from 'graphql-tag'

export const GET_REQUEST_DETAILS = gql`
  fragment project on Project {
    name
    uuid
    url
    brand {
      name
      avatar {
        cloudinaryId
        cloudinaryType
      }
    }
  }

  fragment shoot on Shoot {
    name
    project {
      ... on Project {
        ...project
      }
    }
  }

  fragment video on Video {
    name
    project {
      ... on Project {
        ...project
      }
    }
  }

  query getRequestDetails($uuid: ID!) {
    getRequestTicket(uuid: $uuid) {
      assigneeType
      urgency
      unreadCommentsCount
      state
      resolvedAt
      scheduledFor
      createdAt
      details
      preferredAssigneeUuids
      workedBeforeAssigneeUuids
      target {
        ... on Project {
          ...project
        }
        ... on Shoot {
          ...shoot
        }
        ... on Video {
          ...video
        }
      }
      requesterType
      reassignAt
      requestTicketType {
        category
        requestType
        subcategory
        subtext
        title
        uuid
      }
      uuid
      requester {
        ... on User {
          email
          avatar {
            cloudinaryId
            cloudinaryType
          }
          phoneNumber
          skypeUsername
          name
          uuid
        }
        ... on Gen1Bot {
          avatar {
            cloudinaryId
            cloudinaryType
          }
          name
        }
      }
      moderator {
        ... on User {
          id
          name
          avatar {
            cloudinaryId
            cloudinaryType
          }
        }
      }
      assignee {
        ... on User {
          name
          avatar {
            cloudinaryId
            cloudinaryType
          }
          uuid
          location {
            city
            country
          }
          producerProfile {
            serviceQualityLevel {
              name
              icon {
                cloudinaryId
                cloudinaryType
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/RequestDetailsPage/queries/get-request-details.ts